module.exports = __webpack_public_path__ + "static/media/okr-redirection.719503bc.svg";